import { canViewInstitutionAssets } from '@/composables/useInstitutionAssets'

// Keep Layout lazy: this route list is also imported by the permission store.
// Eager Layout -> navigation -> permission -> asset routes would read Layout before initialization.
// Route access and menu visibility share the existing org:hour:list permission.
export const institutionAssetRoutes = [
  {
    path: '/lesson-assets',
    component: () => import('@/layout/index.vue'),
    hidden: true,
    children: [{
      path: '', name: 'InstitutionLessonAssets',
      component: () => import('@/views/institution/assets/LessonAssets.vue'),
      beforeEnter: () => canViewInstitutionAssets() || { path: '/401' },
      meta: { title: '课时资产', icon: 'lucide-book-open', breadcrumb: false, noCache: true },
    }],
  },
  {
    path: '/compute-assets',
    component: () => import('@/layout/index.vue'),
    hidden: true,
    children: [{
      path: '', name: 'InstitutionComputeAssets',
      component: () => import('@/views/institution/assets/ComputeAssets.vue'),
      beforeEnter: () => canViewInstitutionAssets() || { path: '/401' },
      meta: { title: '算力资产', icon: 'lucide-cpu', breadcrumb: false, noCache: true },
    }],
  },
]
